import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";

const STATS = [
    { value: "24–36%", label: "of parents with minor children have a will" },
    { value: "Majority", label: "of married adults lack basic planning documents" },
    { value: "$124T+", label: "wealth transfer in the U.S. alone through 2048" },
];

export default function Market() {
    return (
        <section
            id="market"
            className="relative mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32"
            data-testid="market"
        >
            <Reveal>
                <SectionLabel index="08">Market Opportunity</SectionLabel>
            </Reveal>

            <Reveal delay={0.1}>
                <h2 className="max-w-4xl font-display text-3xl md:text-5xl font-light leading-[1.15] tracking-tight text-white">
                    The real market is not &ldquo;people who already have estate
                    plans.&rdquo; It is the much larger group of people who have been{" "}
                    <span className="italic text-gold">
                        meaning to create one for years.
                    </span>
                </h2>
            </Reveal>

            <StaggerGroup className="mt-16 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
                {STATS.map((s) => (
                    <StaggerItem key={s.label}>
                        <div className="h-full bg-navy-950 p-8 md:p-10">
                            <p className="font-display text-4xl md:text-5xl font-light text-gold">
                                {s.value}
                            </p>
                            <p className="mt-4 text-sm leading-relaxed text-white/60">
                                {s.label}
                            </p>
                        </div>
                    </StaggerItem>
                ))}
            </StaggerGroup>

            <div className="mt-14 grid gap-8 md:grid-cols-2">
                <Reveal delay={0.15}>
                    <p className="text-base md:text-lg leading-relaxed text-white/70">
                        Most solutions are either complex legal tools that people
                        avoid, or pure technology products that ignore the human
                        reality.
                    </p>
                </Reveal>
                <Reveal delay={0.25}>
                    <p className="border-l-2 border-gold/50 pl-6 text-base md:text-lg leading-relaxed text-white/90">
                        HEIR is the first platform designed to meet people at the
                        moment of delay, and then stay with them for generations.
                    </p>
                </Reveal>
            </div>

            {/* Blue Ocean beat — Phases 2 & 3 */}
            <Reveal delay={0.35}>
                <div className="mt-16 border border-gold/25 bg-gold/[0.04] p-8 md:p-12">
                    <div className="flex items-center gap-3">
                        <span className="h-1.5 w-1.5 rounded-full bg-gold" />
                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            Blue Ocean · Phases 2 &amp; 3
                        </p>
                    </div>
                    <p className="mt-6 max-w-4xl font-display text-2xl md:text-3xl font-light leading-snug text-white">
                        Phase 2 opens a{" "}
                        <span className="italic text-gold">
                            subscription-based agentic estate market
                        </span>{" "}
                        that does not yet exist. Phase 3 opens the{" "}
                        <span className="italic text-gold">
                            trust and generational custody layer
                        </span>{" "}
                        that sits underneath all of it.
                    </p>
                    <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/70">
                        These are not crowded fintech niches. They are
                        category-defining infrastructure for the $124T+
                        generational wealth transfer, and there is no incumbent
                        operating at their intersection today.
                    </p>
                </div>
            </Reveal>
        </section>
    );
}
